import React from "react";

type PaginationItemProps = {
  children: React.ReactNode;
  label: React.ComponentProps<"li">["aria-label"];
  active?: boolean;
  onClick?: React.ComponentProps<"li">["onClick"];
};

const PaginationItem = ({
  children,
  label,
  active,
  onClick,
}: PaginationItemProps) => {
  return (
    <li
      className={[
        "pagination-item",
        active ? "pagination-item-active" : undefined,
      ]
        .filter((value) => value)
        .join(" ")}
      aria-current={active ?? "page"}
      aria-label={label}
      onClick={onClick}
    >
      {children}
    </li>
  );
};

export default PaginationItem;
